import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { SupportedLanguage, LANGUAGE_NAMES } from '../i18n';
import { SiVisa, SiMastercard, SiPaypal, SiAmericanexpress } from 'react-icons/si';
import CookieSettingsButton from './CookieSettingsButton';
import CookieManager from './CookieManager';

const FooterC: React.FC = () => {
  const { t, currentLanguage, changeLanguage, getAvailableLanguages } = useTranslation();
  const navigate = useNavigate();
  
  const handleLanguageChange = async (lang: SupportedLanguage) => {
    if (lang !== currentLanguage) {
      try {
        await changeLanguage(lang);
      } catch (error) {
        console.error('Failed to change language:', error);
      }
    }
  };
  
  return (
    <footer className="bg-black/50 border-t border-gray-800 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-6 xl:gap-8">
          <div className="lg:w-auto">
            <div className="mb-4">
              <img 
                src="https://sonicmakers-uploads.lon1.digitaloceanspaces.com/public/logos/greynoBg.png" 
                alt={t('navigation.vst_shop')}
                className="block"
                style={{ margin: 0, padding: 0, width: '220px', height: '45px', flexShrink: 0 }}
              />
            </div>
            <p className="text-sm pl-2" style={{ color: '#737373' }}>
              {t('footer.company_description')}
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4" style={{ color: '#737373' }}>{t('footer.company_title')}</h4>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => navigate('/about')} className="transition-colors hover:opacity-80 text-left" style={{ color: '#737373' }}>{t('about.page_title')}</button></li>
              <li><button onClick={() => navigate('/plugins')} className="transition-colors hover:opacity-80 text-left" style={{ color: '#737373' }}>{t('navigation.plugins')}</button></li>
              <li><button onClick={() => navigate('/news')} className="transition-colors hover:opacity-80 text-left" style={{ color: '#737373' }}>{t('navigation.news')}</button></li>
              <li><button onClick={() => navigate('/account/downloads')} className="transition-colors hover:opacity-80 text-left" style={{ color: '#737373' }}>{t('navigation.downloads')}</button></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4" style={{ color: '#737373' }}>{t('footer.support_title')}</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="transition-colors hover:opacity-80" style={{ color: '#737373' }}>{t('footer.help')}</a></li>
              <li><button onClick={() => navigate('/contacts')} className="transition-colors hover:opacity-80 text-left" style={{ color: '#737373' }}>{t('footer.contacts')}</button></li>
              <li><a href="#" className="transition-colors hover:opacity-80" style={{ color: '#737373' }}>{t('footer.faq')}</a></li>
              <li><CookieSettingsButton /></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4" style={{ color: '#737373' }}>{t('footer.legal_title')}</h4>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => navigate('/privacy')} className="transition-colors hover:opacity-80 text-left" style={{ color: '#737373' }}>{t('footer.privacy_policy')}</button></li>
              <li><button onClick={() => navigate('/terms')} className="transition-colors hover:opacity-80 text-left" style={{ color: '#737373' }}>{t('footer.terms_of_service')}</button></li>
              <li><button onClick={() => navigate('/cookies')} className="transition-colors hover:opacity-80 text-left" style={{ color: '#737373' }}>{t('footer.cookie_policy')}</button></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4" style={{ color: '#737373' }}>{t('footer.we_accept')}</h4>
            <div className="flex flex-wrap gap-4 items-center -ml-2">
              <SiVisa className="w-10 h-6 transition-colors hover:opacity-80" style={{ color: '#737373' }} />
              <SiMastercard className="w-10 h-6 transition-colors hover:opacity-80" style={{ color: '#737373' }} />
              <SiPaypal className="w-10 h-6 transition-colors hover:opacity-80" style={{ color: '#737373' }} />
              <SiAmericanexpress className="w-10 h-6 transition-colors hover:opacity-80" style={{ color: '#737373' }} />
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
              <p className="text-sm pl-2" style={{ color: '#737373' }}>
                {t('footer.copyright')}
              </p>

              <CookieManager />
            </div>
            
            {/* Language Links - TEMPORARILY DISABLED */}
            {/* <div className="flex items-center space-x-2 text-sm mr-4">
              {getAvailableLanguages().map((lang, index) => (
                <React.Fragment key={lang}>
                  {index > 0 && <span style={{ color: '#737373' }}>|</span>}
                  <button
                    onClick={() => handleLanguageChange(lang)}
                    className={`transition-colors hover:opacity-80 ${
                      currentLanguage === lang ? 'underline underline-offset-8' : ''
                    }`}
                    style={{ color: '#737373' }}
                  >
                    {LANGUAGE_NAMES[lang]}
                  </button>
                </React.Fragment>
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterC; 